import { Box, TextField } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ParentScreenCtx } from "../../../../pages/workbench_build/WorkbenchBuild";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep } from "lodash";
import { treeActions } from "../../../../redux/slices/treeSlice";
import { validateWorkflowItemName } from "../../../../utils/utilFunctions";
import ErrorModal from "../../Forms/FieldDataValidation/ErrorModal";

const ConditionalElse = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const rightSelectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;

  const [name, setName] = useState("");
  
  // Name validation states
  const [nameErrorModal, setNameErrorModal] = useState(false);
  const [nameErrorMessage, setNameErrorMessage] = useState('');

  const saveToRedux = (key, value, bulk) => {
    const clonedData = cloneDeep(translatedData);
    const ifKey = rightSelectedNode?.key
    .split("-")
    .map((v, i, arr) => i === arr.length - 1 ? String(Number(v) - 1) : v)
    .join("-");
    eachDeep(clonedData, (obj) => {
      if (obj?.key === ifKey) {
        obj["ELSE_NAME"] = value || "UNNAMED";
      }

      else if (obj?.key === rightSelectedNode?.key) {
        if (key) {
          if (key === "ELSE_NAME") {
            obj[key] = value || "UNNAMED";
            obj["title"] = value || "UNNAMED";
          } else obj[key] = value;
        } else {
          Object.keys(bulk).forEach((e) => {
            obj[e] = bulk[e];
          });
        }

        dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: rightTree.currentTab,
            data: obj,
          })
        );
      }
    });
    dispatch(
      treeActions.setRightTreeTransData({
        screen: parentScreen,
        type: rightTree.currentTab,
        data: clonedData,
      })
    );
  };

  useEffect(() => {
    setName(rightSelectedNode?.ELSE_NAME || '');
  }, [rightSelectedNode?.key]);

  const handleNameBlur = (eVal) => {
    const oldName = rightSelectedNode?.ELSE_NAME || '';
    
    const validationResult = validateWorkflowItemName(
      eVal, 
      oldName, 
      translatedData, 
      rightSelectedNode?.key, 
      'CONDITIONAL_ELSE'
    );
    
    if (validationResult.isValid) {
      const newName = eVal?.trim() || '';
      setName(newName);
      if (newName !== oldName) {
        saveToRedux('ELSE_NAME', newName);
        // Wait for debounce delay + buffer before dispatching
        setTimeout(() => {
          dispatch(treeActions.setIsInputFocusedFalse());
        }, 200);
      } else {
        // If no change, dispatch immediately
        setTimeout(() => {
          dispatch(treeActions.setIsInputFocusedFalse());
        }, 100);
      }
    } else {
      if (validationResult.errorMessage) {
        setNameErrorMessage(t(validationResult.errorMessage));
        setNameErrorModal(true);
      } else if (validationResult.shouldRevert) {
        setName(oldName);
      }
      // For error cases, dispatch immediately
      setTimeout(() => {
        dispatch(treeActions.setIsInputFocusedFalse());
      }, 100);
    }
  };

  const handleNameErrorModal = (isOpen) => {
    setNameErrorModal(isOpen);
    if (!isOpen) {
      const oldName = rightSelectedNode?.ELSE_NAME || '';
      setName(oldName);
    }
  };

  return (
    <Box>
      <TextField
        fullWidth
        size="small"
        label={t("NAME")}
        name="NAME"
        value={name || ""}
        onChange={(e) => {
          if (parentScreen === "workflow") {
            setName(e.target.value);
          } else {
            const newName = e?.target?.value ? e?.target?.value : "UNNAMED";
            setName(newName);
            saveToRedux("ELSE_NAME", newName);
          }
        }}
        onBlur={parentScreen === "workflow" ? (e) => handleNameBlur(e.target.value) : undefined}
        onFocus={parentScreen === "workflow" ? () => dispatch(treeActions.setIsInputFocusedTrue()) : undefined}
      />
      
      {parentScreen === "workflow" && (
        <ErrorModal
          errorModal={nameErrorModal}
          setErrorModal={setNameErrorModal}
          errorMessage={nameErrorMessage}
          errorType={t('ERROR')}
          handleErrorModal={handleNameErrorModal}
        />
      )}
    </Box>
  );
};

export default ConditionalElse;
